import React from 'react';
import { useRef, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import ViewProfile from '../Profile/ViewProfile';




class Add extends React.Component {
    _isMounted = false
    autocomplete = null
    state = {
        alert: 0,
        alertMessage: '',
        flag: true,
        FullName: '',
        PhoneNumber: '',
        profileAdded: false,
        UniqeID: '',
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Andaman and Nicobar Islands',
            'Bihar',
            'Chandigarh',
            'Chhattisgarh',
            'Delhi',
            'Dadra and Nagar Haveli and Daman and Diu',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu and Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Ladakh',
            'Lakshadweep',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Puducherry',
            'Rajasthan',
            'Sikkim',
            'Tamil Nadu',
            'Telangana',
            'Tripura',
            'Uttar Pradesh',
            'Uttarakhand',
            'West Bengal'
        ]
        
    };


    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.setState({ flag: false });
        
    }



    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    addProfileData = () => {
        let data = {
            FullName: this.state.FullName,
            PhoneNumber:'+91'+this.state.PhoneNumber.substring(this.state.PhoneNumber.length - 10),
            Status: 'PENDING_VERIFICATION',
            UserRole: 'StoreOwners',
            RequestedTimeStamp: this.state.RequestedTimeStamp
                ? this.state.RequestedTimeStamp
                : dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        var validationResult = this.validateAddForm(data);
        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: validationResult.errorMsg
                });
            }
        } else {
            this.setState({ flag: true, alert: 0, alertMessage: '' });
            RestServices.AddProfile(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (responseData.status) {
                            if (this._isMounted) {
                                this.setState({
                                    profileAdded: true,
                                    UniqeID: responseData.UniqeID,
                                    flag: false,
                                    alert: 2,
                                    alertMessage:
                                        'Profile created, Please Add Profile details...'
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 1,
                                    alertMessage: responseData.message
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        }
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.flag && <Spinner animation="border" />}

                {!this.state.profileAdded && (
                    <div>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Full Name (As per PAN Card)</Form.Label>
                                <Form.Control
                                    placeholder="Enter Full Name"
                                    type="text"
                                    name="FullName"
                                    value={this.state.FullName}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Mobile Number</Form.Label>
                                <Form.Control
                                    placeholder="Enter Mobile Number"
                                    type="text"
                                    name="PhoneNumber"
                                    value={this.state.PhoneNumber}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                        </Form.Row>
                
                        
                        <hr />
                        <Form.Row>
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={this.addProfileData}
                            >
                                Add New
                            </Button>
                        </Form.Row>
                    </div>
                )}

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.profileAdded && (
                    <div>
                        <ViewProfile
                            selectedUserRole="StoreOwners"
                            UniqeID={this.state.UniqeID}
                            {...this.props}
                        />
                    </div>
                )}
            </Container>
        );
    }

    validateAddForm = () => {
        let isError = false;
        let errorMsg = '';
        if (this.state.FullName == '') {
            isError = true;
            errorMsg = 'Please enter Full Name';
        }

        let PhoneNumber = this.state.PhoneNumber.replace('+91', '').trim();
        PhoneNumber = PhoneNumber.replace('+91 ', '').trim();
        PhoneNumber = PhoneNumber.replace('91 ', '').trim();
        if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
            isError = true;
            errorMsg = errorMsg + ' Please enter valid Primary Phone Number.';
        }
        var reurndate = [];
        reurndate.isError = isError;
        reurndate.errorMsg = errorMsg;
        return reurndate;
    };
}

export default Add;
